angular.module('siter.io').directive 'iframeOnload', [ ->
  {
    scope: callBack: '&iframeOnload'
    link: (scope, element, attrs) ->
      element.on 'load', ->
        scope.callBack()
      return
  }
 ]



// WEBPACK FOOTER //
// ./src/app/common/directives/iframeonload.coffee